<h2 i18n class="title-vertical-center">Waiting for players</h2>
